<template>
    <span class="label"
          data-component="MellonWebECRTransactionResultLabel"
          :class="color">
        {{ text }}
    </span>
</template>

<script>
export default {
    props: {
        /**
         * @type {MellonWebECRTransaction}
         */
        transaction: {
            type: Object,
            required: true,
        },
    },

    computed: {
        color() {
            if (this.transaction) {
                if (this.transaction.Voided) {
                    return 'label-danger';
                }

                if (this.transaction.Approved) {
                    return 'label-success';
                }
            }

            return '';
        },

        text() {
            if (this.transaction) {
                if (this.transaction.Voided) {
                    return 'VOIDED';
                }

                if (this.transaction.Approved) {
                    return 'APPROVED';
                }
            }

            return '';
        },
    },
};
</script>
